import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { NewNavbar, BreadCrumbsNew, NewFooter } from "../../components";
import InputField from "../../components/ConsultationTranscribedPrescriptions/InputField";
import RadioGroup from "../../components/ConsultationTranscribedPrescriptions/RadioGroup";
import CheckboxGroup from "../../components/ConsultationTranscribedPrescriptions/CheckboxGroup";
import BackBtn from "../../assets/images/backicon.jpg";
import "./index.css";

const steps = [
  {
    id: 1,
    type: "input",
    label: "Your Name",
    name: "name",
    description:
      "We ask for your name to check if you've had a consultation before.",
  },
  {
    id: 2,
    type: "radio",
    label: "Have you had a consultation before?",
    name: "consultation",
    options: [
      { label: "Yes, I have consulted before", value: "yes" },
      { label: "No, start a new consultation", value: "no" },
    ],
  },
  {
    id: 3,
    type: "checkbox",
    label: "Select your symptoms",
    name: "symptoms",
    options: [
      { label: "Headache", value: "headache" },
      { label: "Fever", value: "fever" },
      { label: "Nausea", value: "nausea" },
    ],
  },
  {
    id: 4,
    type: "input",
    label: "Email Address",
    name: "email",
    description: "We'll use this to contact you with results or questions.",
  },
];

const TRConsultation = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});

  const currentStep = steps[step - 1];

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRadioChange = (value) => {
    setFormData({ ...formData, [currentStep.name]: value });
  };

  const handleCheckboxChange = (value) => {
    const selected = formData[currentStep.name] || [];
    const updated = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    setFormData({ ...formData, [currentStep.name]: updated });
  };

  const handleNext = () => {
    if (step < steps.length) setStep(step + 1);
  };

  const handlePrevious = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Submitted Data:", formData);
    // further logic here
  };

  return (
    <div className="transcribed-consultation-form">
      <div className="py-7 px-4 mb-0 mt-6 text-center header-form-wrap">
        <img src="/logo.png" width={150} />
      </div>

      <div className="mt-0 container">
        <div className="row justify-content-md-center g-3">
          <div className="col-12">
            <div className="w-form fade-in">
              <div className="row g-5">
                <div className="col-lg-12">
                  <Form onSubmit={handleSubmit}>
                    <Form.Group controlId={`formStep${currentStep.id}`}>
                      <h5 className="mb-10">{currentStep.label}</h5>
                      {currentStep.description && (
                        <p className="mb-4">{currentStep.description}</p>
                      )}

                      {currentStep.type === "input" && (
                        <InputField
                          label=""
                          name={currentStep.name}
                          value={formData[currentStep.name] || ""}
                          onChange={handleInputChange}
                        />
                      )}

                      {currentStep.type === "radio" && (
                        <RadioGroup
                          name={currentStep.name}
                          options={currentStep.options}
                          selectedValue={formData[currentStep.name] || ""}
                          onChange={handleRadioChange}
                        />
                      )}

                      {currentStep.type === "checkbox" && (
                        <CheckboxGroup
                          label=""
                          name={currentStep.name}
                          options={currentStep.options}
                          selectedValues={formData[currentStep.name] || []}
                          onChange={handleCheckboxChange}
                        />
                      )}
                    </Form.Group>

                    <div className="d-flex justify-content-between mt-4">
                      {step > 1 && (
                        <div className="card-footer p-0 d-flex align-items-center gap-2 bg-transparent border-0">
                          <img
                            src={BackBtn}
                            onClick={handlePrevious}
                            width="35px"
                            className="cursor-pointer"
                            alt="Back"
                          />
                        </div>
                      )}

                      {step < steps.length ? (
                        <div className="card-footer p-0 d-flex align-items-center gap-2 bg-transparent border-0 w-auto">
                          <button
                            type="button"
                            className="btncust w-100 activebg"
                            onClick={handleNext}
                          >
                            Next
                          </button>
                        </div>
                      ) : (
                        <div className="card-footer p-0 d-flex align-items-center gap-2 bg-transparent border-0 w-100">
                          <button type="submit" className="btncust w-auto activebg">
                            Submit
                          </button>
                        </div>
                      )}
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { TRConsultation };
